import { CircularProgress, css, styled } from '@mui/material'

import { customCommonColors, hubloTheme } from '@front/theme'

import type { CircularLoadingSize } from './CircularLoading'

const MARGINS_BY_SIZE: Record<CircularLoadingSize, string> = {
  small: hubloTheme.spacing(0),
  large: hubloTheme.spacing(5, 0),
}

export const CircularProgressWrapper = styled('div')<{
  size: CircularLoadingSize
  loaderSize: number
}>`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ size, loaderSize }) => css`
    margin: ${MARGINS_BY_SIZE[size]};
    height: ${loaderSize}px;
  `}
`
export const StyledCircularProgressBackground = styled(CircularProgress)`
  position: absolute;
  color: ${customCommonColors.blue15};
`

export const StyledCircularProgress = styled(CircularProgress)`
  position: absolute;
  color: ${customCommonColors.grey5};
`
